import React from 'react';
import { Route } from 'react-router-dom';
import { AuthRoute, ProtectedRoute } from '../util/route_util';
import { Switch } from 'react-router-dom';
import MainPage from './main/main_page';
import Completion from './main/completion';

import './App.css';


const App = () => (
  <div className="main">
      <Route exact path="/:id" component={MainPage} />
      <Route exact path="/completion" component={Completion} />
  </div>
);

export default App;